<template>
  <div>
    <div class="logistics" v-if="!othertrans.length">
      <header class="orderSource">
        <ul>
          <li style="width: 67%">订单编号：<b><input id="orderNo" type="text" :value="list.orderno" readonly="readonly" />{{list.orderno}}</b><i v-if="list.orderno" @click="copy(0)">复制</i></li>
          <li>发货时间：<b>{{list.shiptime}}</b></li>
          <li>物流公司：<b>{{list.transname}}</b></li>
          <li>物流单号：<b><input id="transNo" type="text" :value="list.transno" readonly="readonly" />{{list.transno}}</b><i v-if="list.transno" @click="copy(1)">复制</i></li>
          <li v-if="list.deliverytime">预计送达：<b>{{list.deliverytime}}</b></li>
        </ul>
        <p class="f12 color-FC0324" v-if="list.ismergeorder == 1">与其他订单合并发出</p>
      </header>
      <div class="logisticsDetails" v-if="list.list.length">
<!--<ul>
		  <li v-for="(item, index) of list" :key="index" :class="{'blackText': item.isStatus}">
        <img v-if="item.isStatus" :src="item.imgUrl">
        <img v-if="!item.isStatus" :src="item.beforeImgUrl">
        <p>{{item.title}}</p>
        <b>{{item.content}}</b>
        <span>{{item.time}}</span>
        <ul v-if="item.children && item.children.length > 0 ">
          <li v-for="(itemSon, indexSon) of item.children" :key="indexSon" :class="{'blackText': itemSon.isStatus}">
            <img v-if="itemSon.isStatus" :src="item.imgUrl">
            <img v-else-if="!itemSon.isStatus" :src="item.beforeImgUrl">
            <b>{{itemSon.content}}</b>
            <span>{{itemSon.time}}</span>
          </li>
        </ul>
		  </li>
		</ul>-->
        <ul>
          <li v-for="(item, index) of list.list" :key="index" :class="{'blackText': index == 0}">
            <img v-if="index == 0" src="../../assets/images/round.png">
            <img v-else src="../../assets/images/round1.png">
            <!--<p>{{item.title}}</p>-->
            <b>{{item.info}}</b>
            <span>{{item.time}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      <div class="logistics" v-for="item of othertrans">
        <header class="orderSource">
          <ul>
            <li style="width: 67%">订单编号：<b><input id="orderNo" type="text" :value="item.orderno" readonly="readonly" />{{item.orderno}}</b><i v-if="item.orderno" @click="copy(0)">复制</i></li>
            <li>发货时间：<b>{{item.shiptime}}</b></li>
            <li>物流公司：<b>{{item.transname}}</b></li>
            <li>物流单号：<b><input id="transNo" type="text" :value="item.transno" readonly="readonly" />{{item.transno}}</b><i v-if="item.transno" @click="copy(1)">复制</i></li>
            <li v-if="item.deliverytime">预计送达：<b>{{list.deliverytime}}</b></li>
          </ul>
          <p class="f12 color-FC0324" v-if="item.ismergeorder == 1">与其他订单合并发出</p>
        </header>
        <div class="logisticsDetails" v-if="item.list.length">
          <!--<ul>
					<li v-for="(item, index) of list" :key="index" :class="{'blackText': item.isStatus}">
				  <img v-if="item.isStatus" :src="item.imgUrl">
				  <img v-if="!item.isStatus" :src="item.beforeImgUrl">
				  <p>{{item.title}}</p>
				  <b>{{item.content}}</b>
				  <span>{{item.time}}</span>
				  <ul v-if="item.children && item.children.length > 0 ">
					<li v-for="(itemSon, indexSon) of item.children" :key="indexSon" :class="{'blackText': itemSon.isStatus}">
					  <img v-if="itemSon.isStatus" :src="item.imgUrl">
					  <img v-else-if="!itemSon.isStatus" :src="item.beforeImgUrl">
					  <b>{{itemSon.content}}</b>
					  <span>{{itemSon.time}}</span>
					</li>
				  </ul>
					</li>
				  </ul>-->
          <ul>
            <li v-for="(listitem, listindex) of item.list" :key="listindex" :class="{'blackText': listindex == 0}">
              <img v-if="listindex == 0" src="../../assets/images/round.png">
              <img v-else src="../../assets/images/round1.png">
              <!--<p>{{item.title}}</p>-->
              <b>{{listitem.info}}</b>
              <span>{{listitem.time}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isWeixin, fenxiang, copyContentH5 } from '../../assets/common/js/config'

export default {
  name: 'logisticsDetails',
  data () {
    return {
      id: this.$route.query.id ? this.$route.query.id : '',
      list: [],
      othertrans: []
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'logisticsdetails'})
    }
    this.getData()
  },
  methods: {
    getData () {
      if (this.id != '') {
        var url = this.$ajax.getLogistics_URL+'?id=' + this.id
        if (this.$route.query.tranno) url += ('&tranno=' + this.$route.query.tranno)
        var that = this
        that.$customRequestAjax(url).then(res => {
          if (res.data.code === 200) {
            that.list = res.data
            that.othertrans = res.data.othertrans
          }
        })
      }
    },
    copy: function (type) {
      if (type == 0) {
        copyContentH5(this.list.orderno, 'orderNo')
      } else {
        copyContentH5(this.list.transno, 'transNo')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .logistics {
    background: #fff;
    border-top: .1rem solid #eee;
    &:first-of-type {
      border-top-width: 0;
    }
    .orderSource {
      background: #fff;
      padding: 0.1rem 0.11rem 0.15rem;
      border-radius: 0.03rem;
      border-bottom: .1rem solid #eee;
      position: relative;
      >p {
        position: absolute;
        right: 0.11rem;
        top: 0.1rem;
      }
      ul{
        li{
          font-size:0.12rem;
          font-weight:400;
          color:rgba(61,61,61,1);
          line-height:0.17rem;
          margin-top: 0.1rem;
          &:first-of-type {
            margin-top: 0;
          }
          b {
            font-size:0.12rem;
            font-weight:600;
            color:rgba(51,51,51,1);
            line-height:0.17rem;
            #orderNo,#transNo {
              border-width: 0;
              outline: none;
              position: absolute;
              top: -99rem;
            }
          }
          i {
            font-style: normal;
            font-size:0.1rem;
            font-weight:400;
            color:rgba(74,144,226,1);
            line-height:0.17rem;
            margin-left: 0.06rem;
          }
        }
      }
    }
    .logisticsDetails {
      background: #fff;
      padding: 0.2rem 0.15rem;
      border-radius: 0.03rem;
      >ul {
        padding-left: 0.11rem;
        >li {
          padding-bottom: 0.22rem;
          padding-left: 0.25rem;
          position: relative;
          border-left: 1px solid #D8D8D8;
          position: relative;
          &.blackText {
            /*>p {*/
              /*color: #2E2D2D;*/
            /*}*/
            >b {
              color: #2E2D2D;
            }
          }
          &:last-of-type {
            /*border-left: none;*/
          }
          >img {
            width: 0.08rem;
            height: 0.08rem;
            position: absolute;
            left: -0.04rem;
            top: 35%;
          }
          /*>p {
            font-size:0.16rem;
            font-weight:600;
            color: #858585;
            line-height:0.22rem;
          }*/
          b {
            display: block;
            font-size:0.14rem;
            font-weight:400;
            color:#858585;
            line-height:0.23rem;
            padding-top: 0.06rem;
            margin-bottom: 0.04rem;
          }
          span {
            display: block;
            font-size:0.12rem;
            font-weight:600;
            color:rgba(153,153,153,1);
            line-height:0.17rem;
          }
          /*>ul {
            >li {
              position: relative;
              margin-bottom: 0.13rem;
              &.blackText {
                p {
                  color: #2E2D2D;
                }
                b {
                  color: #2E2D2D;
                }
              }
              >img {
                width: 0.08rem;
                height: 0.08rem;
                position: absolute;
                left: -0.29rem;
                top: 46%;
              }
              &:last-of-type {
                margin-bottom: 0;
              }
            }
          }*/
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/order/logisticsDetails.vue